/**
 * When invoked repeatedly, will only actually call the original function at most once per every wait milliseconds.
 * Useful for rate-limiting events that occur faster than you can keep up with.
 *
 * @example
 *   input.addEventListener('input', (event) => console.log(event, 'normal'));
 *   input.addEventListener('input', new ThrottleEventListener((event) => console.log(event, 'throttle'), 250));
 */
// See https://developer.mozilla.org/en-US/docs/Web/API/EventListener

export default class ThrottleEventListener {
  #timeoutID = 0;
  #listener;
  #delay;

  constructor(listener, delay = 0) {
    this.#listener = listener;
    this.#delay = delay;
  }

  #exec(listener) {
    if (this.#timeoutID !== 0) return;

    this.#timeoutID = setTimeout(() => {
      this.#timeoutID = 0;
    }, this.#delay);

    listener();
  }

  handleEvent(event) {
    this.#exec(() => this.#listener(event));
  }
}
